import { LOAD_MODAL_CONTAINER, CLOSE_MODAL_CONTAINER } from '../constants/ActionTypes';


function loadModalContainer(channel) {
  return dispatch =>
    dispatch({
      type: LOAD_MODAL_CONTAINER,
      payload: channel,
    });
}
function closeModalContainer() {
  return dispatch =>
    dispatch({
      type: CLOSE_MODAL_CONTAINER,
    });
}

module.exports = {
  loadModalContainer,
  closeModalContainer,
};
